const access = {
    BROKER: 'Broker',
    ANALYST: "Analyst",
    FINANCIAL_ADVISER: 'Financial Advisor',
    NON_FINANCE: 'Non Financial Advisor',
    STUDENT: 'Student',
    OTHER: 'Other',
    RETAIL_INVESTOR: 'Retail Investor',
    MARKET_EXPERT: 'Market Expert',
    DEALER: 'Dealer',
    ADMIN: 'Admin',
    ALL: 'All'
  };

  exports.access = access;
